import React, { useState, useEffect, useCallback } from "react";
import { scanApi } from "../utils/scanApi";
import { brand } from "../theme/brandTheme";
const BRAND = {
  primary: "#6BCE8B",
  primaryDark: "#4EAD6E",
  primaryLight: "#E8F8EE",

  secondary: "#035EA5",
  secondaryLight: "#E6F0F9",

  white: "#FFFFFF",

  gray50: "#F8FAFC",
  gray100: "#F1F5F9",
  gray200: "#E2E8F0",
  gray300: "#CBD5E1",
  gray400: "#94A3B8",
  gray500: "#64748B",
  gray600: "#475569",
  gray900: "#0F172A",
};

const FONT = "'Inter', sans-serif";
// ─── Styles ──────────────────────────────────────────────────────
const CS = {
  wrapper: {
    width: "100%",
    height: "calc(100vh - 60px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
  },
 blurOverlay: {
  position: "absolute",
  inset: 0,
  background: "rgba(3,94,165,0.15)",
  backdropFilter: "blur(4px)",
  zIndex: 0,
},
  modal: {
  background: BRAND.white,
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "14px",
  width: "100%",
  maxWidth: 720,
  maxHeight: "calc(100vh - 120px)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxShadow: "0 25px 60px rgba(3,94,165,0.2)",
  position: "relative",
  zIndex: 1,
},
  // header: {
  //   padding: "28px 32px 20px",
  //   borderBottom: `1px solid ${brand.colors.divider}`,
  //   background: brand.colors.surface,
  //   position: "relative",
  //   flexShrink: 0,
  //   borderRadius: `${brand.radius.xl} ${brand.radius.xl} 0 0`,
  // },

  header: {
  padding: "20px 24px",
  borderBottom: `1px solid ${BRAND.gray200}`,
  background: BRAND.white,
},
  // headerAccent: {
  //   position: "absolute", top: 0, left: 0, right: 0, height: 4,
  //   // background: `linear-gradient(90deg, #FF4D6A, ${brand.colors.secondary}, ${brand.colors.primary})`,
  //   borderRadius: `${brand.radius.xl} ${brand.radius.xl} 0 0`,
  // },
 headerTitle: {
  fontSize: 18,
  fontWeight: 700,
  color: BRAND.gray900,
  display: "flex",
  alignItems: "center",
  gap: 10,
  margin: 0,
  fontFamily: FONT,
},

headerSub: {
  fontSize: 13,
  color: BRAND.gray500,
  marginTop: 4,
  fontFamily: FONT,
},
  body: {
  padding: "20px 24px",
  overflowY: "auto",
  flex: 1,
},
 sectionTitle: {
  fontSize: 13,
  fontWeight: 700,
  color: BRAND.gray900,
  textTransform: "uppercase",
  letterSpacing: 0.6,
  marginBottom: 14,
  paddingBottom: 6,
  borderBottom: `1px solid ${BRAND.gray200}`,
},
  formGrid: {
    display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 24,
  },
  label: {
    display: "block", fontSize: 11, fontWeight: 700,
    color: brand.colors.textSecondary, textTransform: "uppercase",
    letterSpacing: 0.8, marginBottom: 6,
  },
  star: { color: brand.colors.critical, marginLeft: 2 },
  input: {
  width: "100%",
  padding: "10px 14px",
  background: "#fff",
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "8px",
  color: BRAND.gray900,
  fontSize: 13,
  fontFamily: FONT,
  outline: "none",
},
  inputErr: {
    borderColor: brand.colors.critical,
    boxShadow: `0 0 0 2px ${brand.colors.critical}20`,
  },
  errText: { fontSize: 11, color: brand.colors.critical, marginTop: 4, fontWeight: 500 },
 declBox: {
  background: BRAND.gray50,
  border: `1px solid ${BRAND.gray200}`,
  borderRadius: "10px",
  padding: 20,
  fontSize: 13,
  color: BRAND.gray600,
  lineHeight: 1.7,
},
  hl: { color: brand.colors.primary, fontWeight: 600 },
 cbRow: (checked, hasError) => ({
  display: "flex",
  gap: 12,
  padding: "14px 18px",
  background: checked ? BRAND.primaryLight : "#fff",
  border: `1px solid ${hasError ? "#DC2626" : checked ? BRAND.primary : BRAND.gray200}`,
  borderRadius: "10px",
  cursor: "pointer",
}),

cb: (checked) => ({
  width: 20,
  height: 20,
  borderRadius: 4,
  border: `1px solid ${checked ? BRAND.primary : BRAND.gray300}`,
  background: checked ? BRAND.primary : "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}),
  cbLabel: { fontSize: 13, color: brand.colors.text, fontWeight: 500, lineHeight: 1.6 },
  footer: {
  padding: "16px 24px",
  borderTop: `1px solid ${BRAND.gray200}`,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: BRAND.white,
},
  footerNote: { fontSize: 11, color: brand.colors.textMuted, maxWidth: 300 },
  footerActions: { display: "flex", gap: 12 },
  timestamp: {
    fontSize: 11, color: brand.colors.textMuted,
    display: "flex", alignItems: "center", gap: 6, marginTop: 8,
  },
  spinner: {
    display: "inline-block", width: 16, height: 16,
    border: `2px solid ${brand.colors.surfaceBorder}`,
    borderTopColor: brand.colors.primary, borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
 btnPrimary: {
  padding: "10px 18px",
  background: BRAND.secondary,
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: FONT,
},
  btnOutline: {
    padding: "8px 16px", background: "transparent", color: brand.colors.secondary,
    border: `1px solid ${brand.colors.secondary}40`, borderRadius: brand.radius.sm,
    fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: brand.font,
    whiteSpace: "nowrap", transition: "all 0.25s ease",
  },
  btnDisabled: { opacity: 0.5, cursor: "not-allowed" },
  scopeBox: {
    padding: "11px 14px", background: `${brand.colors.primary}08`,
    border: `1px solid ${brand.colors.primaryBorder}`,
    borderRadius: brand.radius.md, fontSize: 13,
    color: brand.colors.textSecondary, lineHeight: 1.6,
  },
 infoBox: {
  background: BRAND.secondaryLight,
  border: `1px solid ${BRAND.secondaryLight}`,
  borderRadius: "8px",
  padding: "12px 16px",
  fontSize: 12,
  color: BRAND.secondary,
},
 warnBox: {
  background: "#FDE8E8",
  border: "1px solid #FECACA",
  borderRadius: "8px",
  padding: "10px 14px",
  fontSize: 11,
  color: "#9B1C1C",
},
};

// ─── Form Field ──────────────────────────────────────────────────
const FormField = React.memo(({ name, label, type, placeholder, half, value, error, onChangeCb, onFocusCb, onBlurCb }) => (
  <div style={half ? {} : { gridColumn: "1 / -1" }}>
    <label style={CS.label}>
      {label} <span style={CS.star}>*</span>
    </label>
    <input
      style={{ ...CS.input, ...(error ? CS.inputErr : {}) }}
      type={type || "text"}
      placeholder={placeholder}
      value={value}
      onChange={onChangeCb}
      onFocus={onFocusCb}
      onBlur={onBlurCb}
    />
    {error && <div style={CS.errText}>{error}</div>}
  </div>
));

// ─── Component ───────────────────────────────────────────────────
const ScanConsentModal = ({
  isOpen,
  onClose,
  onConsentAccepted,
  targetUrl,
  organizationId,
  profile,
  userData,
  showToast,
}) => {
  const isPageLevel = !targetUrl;
  const preventClose = !onClose || onClose.toString() === "() => {}";
  const userId = userData?.["cognito:username"];

  const [form, setForm] = useState({
    fullName: "",
    designation: "",
    companyName: "",
    workEmail: "",
    contactNumber: "",
    domainToScan: "",
    consentChecked: false,
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && profile) {
      setForm((prev) => ({
        ...prev,
        fullName: prev.fullName || profile.name || "",
        workEmail: prev.workEmail || profile.email || "",
        companyName: prev.companyName || profile.orgName || "",
        domainToScan: prev.domainToScan || targetUrl || "",
      }));
    }
  }, [isOpen, profile, targetUrl]);

  const validate = () => {
    const e = {};
    if (!form.fullName.trim()) e.fullName = "Full name is required";
    if (!form.designation.trim()) e.designation = "Designation is required";
    if (!form.companyName.trim()) e.companyName = "Company name is required";
    if (!form.workEmail.trim()) e.workEmail = "Work email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.workEmail))
      e.workEmail = "Invalid email format";
    if (!form.contactNumber.trim()) e.contactNumber = "Contact number is required";
    if (!form.domainToScan.trim()) e.domainToScan = "Domain to scan is required";
    else {
      try {
        new URL(form.domainToScan.trim());
      } catch {
        e.domainToScan = "Enter a valid URL (e.g. https://example.com)";
      }
    }
    if (!form.consentChecked)
      e.consentChecked = "You must accept the consent to proceed";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    try {
      const payload = {
        userId: userId,
        fullName: form.fullName.trim(),
        designation: form.designation.trim(),
        companyName: form.companyName.trim(),
        workEmail: form.workEmail.trim(),
        contactNumber: form.contactNumber.trim(),
        domainToScan: form.domainToScan.trim(),
        consentAccepted: true,
        consentTimestamp: new Date().toISOString(),
        consentVersion: "1.0",
        ipAddress: null,
      };
      await scanApi.recordScanConsent(organizationId, payload);
      setForm({
        fullName: "", designation: "", companyName: "",
        workEmail: "", contactNumber: "", domainToScan: "",
        consentChecked: false,
      });
      setErrors({});
      onConsentAccepted();
    } catch (err) {
      showToast(err.message || "Failed to record consent", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleFocus = useCallback((e) => {
   e.target.style.borderColor = BRAND.secondary;
e.target.style.boxShadow = `0 0 0 3px ${BRAND.secondaryLight}`;
  }, []);

  const blurHandler = useCallback((e) => {
    e.target.style.borderColor = BRAND.secondary;
e.target.style.boxShadow = `0 0 0 3px ${BRAND.secondaryLight}`;
  }, []);

  const changeFullName    = useCallback((e) => { setForm(p => ({ ...p, fullName: e.target.value }));      setErrors(p => { if (!p.fullName) return p;      const n = { ...p }; delete n.fullName;      return n; }); }, []);
  const changeDesignation = useCallback((e) => { setForm(p => ({ ...p, designation: e.target.value }));   setErrors(p => { if (!p.designation) return p;   const n = { ...p }; delete n.designation;   return n; }); }, []);
  const changeCompanyName = useCallback((e) => { setForm(p => ({ ...p, companyName: e.target.value }));   setErrors(p => { if (!p.companyName) return p;   const n = { ...p }; delete n.companyName;   return n; }); }, []);
  const changeContactNum  = useCallback((e) => { setForm(p => ({ ...p, contactNumber: e.target.value })); setErrors(p => { if (!p.contactNumber) return p;  const n = { ...p }; delete n.contactNumber; return n; }); }, []);
  const changeEmail       = useCallback((e) => { setForm(p => ({ ...p, workEmail: e.target.value }));     setErrors(p => { if (!p.workEmail) return p;     const n = { ...p }; delete n.workEmail;     return n; }); }, []);
  const changeDomain      = useCallback((e) => { setForm(p => ({ ...p, domainToScan: e.target.value }));  setErrors(p => { if (!p.domainToScan) return p;   const n = { ...p }; delete n.domainToScan; return n; }); }, []);

  if (!isOpen) return null;

  // Derive display domain for declaration
  const displayDomain = form.domainToScan.trim() || targetUrl || "[Domain]";

  return (
    <div style={CS.wrapper}>
      <div style={CS.blurOverlay} />
      <div style={CS.modal}>
        {/* ═══ HEADER ═══ */}
        <div style={CS.header}>
          {/* <div style={CS.headerAccent} /> */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <h2 style={CS.headerTitle}>🛡️ Domain Authorization & Scanning Consent</h2>
              <p style={CS.headerSub}>Please provide the following details before accessing the scanner</p>
            </div>
            {/* {!preventClose && (
              <button onClick={onClose} style={{ background: "none", border: "none", color: brand.colors.textMuted, fontSize: 24, cursor: "pointer", padding: 4 }}>×</button>
            )} */}
          </div>
        </div>

        {/* ═══ BODY ═══ */}
        <div style={CS.body}>
          <div style={CS.sectionTitle}>👤 Authorized Representative Information</div>
          <div style={CS.formGrid}>
            <FormField name="fullName" label="Full Name" placeholder="Enter your full name" half
              value={form.fullName} error={errors.fullName}
              onChangeCb={changeFullName} onFocusCb={handleFocus} onBlurCb={blurHandler} />

            <FormField name="designation" label="Designation / Role" placeholder="e.g. CTO, Security Lead" half
              value={form.designation} error={errors.designation}
              onChangeCb={changeDesignation} onFocusCb={handleFocus} onBlurCb={blurHandler} />

            <FormField name="companyName" label="Company Name" placeholder="Your organization name" half
              value={form.companyName} error={errors.companyName}
              onChangeCb={changeCompanyName} onFocusCb={handleFocus} onBlurCb={blurHandler} />

            <FormField name="contactNumber" label="Contact Number" type="tel" placeholder="+91 XXXXX XXXXX" half
              value={form.contactNumber} error={errors.contactNumber}
              onChangeCb={changeContactNum} onFocusCb={handleFocus} onBlurCb={blurHandler} />

            <FormField name="workEmail" label="Work Email Address" type="email" placeholder="name@company.com"
              value={form.workEmail} error={errors.workEmail}
              onChangeCb={changeEmail} onFocusCb={handleFocus} onBlurCb={blurHandler} />

            {/* ✅ Domain to scan field */}
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={CS.label}>Domain to be Scanned <span style={CS.star}>*</span></label>
              {isPageLevel ? (
                <>
                  <input
                    style={{ ...CS.input, ...(errors.domainToScan ? CS.inputErr : {}) }}
                    type="url"
                    placeholder="https://example.com"
                    value={form.domainToScan}
                    onChange={changeDomain}
                    onFocus={handleFocus}
                    onBlur={blurHandler}
                  />
                  {errors.domainToScan && <div style={CS.errText}>{errors.domainToScan}</div>}
                  <div style={{ ...CS.scopeBox, marginTop: 8 }}>
                    This consent authorizes SUSAN to perform DAST security scans on the domain specified above.
                  </div>
                </>
              ) : (
                <>
                  <input
                    style={{ ...CS.input, opacity: 0.7, cursor: "not-allowed" }}
                    value={targetUrl}
                    readOnly
                  />
                </>
              )}
            </div>
          </div>

          <div style={CS.timestamp}>
            🕐 Authorization Timestamp:{" "}
            <strong style={{ color: brand.colors.text }}>
              {new Date().toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" })}
            </strong>
            <span style={{ fontSize: 10, color: brand.colors.textMuted }}> (auto-recorded by SUSAN)</span>
          </div>

          <div style={{ ...CS.sectionTitle, marginTop: 24 }}>📜 Declaration of Authorization</div>
          <div style={CS.declBox}>
            <p style={{ marginTop: 0 }}>
              I, <span style={CS.hl}>{form.fullName || "[Full Name]"}</span>,
              in my capacity as{" "}
              <span style={CS.hl}>{form.designation || "[Designation]"}</span> at
              <span style={CS.hl}> {form.companyName || "[Company Name]"}</span>,
              am requesting this security scan for the legitimate security
              assessment purposes of my organization and hereby authorize{" "}
              <strong>SUSAN</strong> to perform Application Security Testing
              on the domain <span style={CS.hl}>{displayDomain}</span>.
            </p>
            <p style={{ marginBottom: 4 }}>I further confirm that:</p>
            <ol style={{ paddingLeft: 20, margin: 0 }}>
              <li style={{ marginBottom: 8 }}>I am the lawful owner of <strong>{displayDomain}</strong> or have obtained explicit authorization from the lawful owner to conduct security testing.</li>
              <li style={{ marginBottom: 8 }}>The information provided above is true, accurate, and complete.</li>
              <li style={{ marginBottom: 8 }}>I authorize SUSAN to act as an independent third-party security testing agent on my behalf.</li>
              <li style={{ marginBottom: 8 }}>I understand that security testing may generate automated traffic, alerts, or temporary performance impact on <strong>{displayDomain}</strong>.</li>
              <li style={{ marginBottom: 8 }}>I accept full legal, regulatory, and operational responsibility for this scan.</li>
              <li style={{ marginBottom: 8 }}>I confirm that this activity complies with all applicable laws, regulations, hosting agreements, and third-party service terms.</li>
              <li style={{ marginBottom: 0 }}>SUSAN shall not be held liable for unauthorized testing, misuse, false declarations, or any direct or indirect consequences arising from this scan.</li>
            </ol>
          </div>

          <div style={CS.infoBox}>
            <strong style={{ color: brand.colors.secondaryLight }}>🔒 Domain Verification & Protection:</strong>{" "}
            Before a scan begins, domain ownership verification may be required.
            Once verified, the domain is securely locked to your organization to prevent unauthorized scanning.
          </div>

          <div style={{ ...CS.sectionTitle, marginTop: 0 }}>✅ Mandatory Consent Confirmation</div>
          <div
            style={CS.cbRow(form.consentChecked, !!errors.consentChecked)}
            onClick={() => {
              setForm((p) => ({ ...p, consentChecked: !p.consentChecked }));
              if (errors.consentChecked) {
                setErrors((prev) => { const next = { ...prev }; delete next.consentChecked; return next; });
              }
            }}
          >
            <div style={CS.cb(form.consentChecked)}>
              {form.consentChecked && (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M11.5 4L5.5 10L2.5 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
            <span style={CS.cbLabel}>
              I, <strong>{form.fullName || "[Full Name]"}</strong>, confirm that
              I am authorized to allow SUSAN to perform security scans
              on <strong>{displayDomain}</strong>{" "}
              for legitimate security purposes and accept full responsibility for this request.
            </span>
          </div>
          {errors.consentChecked && (
            <div style={{ ...CS.errText, marginTop: -16, marginBottom: 16 }}>⚠️ {errors.consentChecked}</div>
          )}

          <div style={CS.warnBox}>
            ⚠️ If you do not have proper authorization to scan any domain,{" "}
            <strong style={{ color: brand.colors.critical }}>you must not proceed</strong>.
            The scanner cannot be accessed unless the consent checkbox above is selected.
          </div>
        </div>

        {/* ═══ FOOTER ═══ */}
        <div style={CS.footer}>
          <div style={CS.footerNote}>🔐 Your consent is securely recorded and timestamped by SUSAN for audit compliance.</div>
          <div style={CS.footerActions}>
            {/* {!preventClose && (
              <button className="dast-btn" style={CS.btnOutline} onClick={onClose}>Cancel</button>
            )} */}
            <button
              className="dast-btn"
              style={{
                ...CS.btnPrimary,
                ...((submitting || !form.consentChecked) ? CS.btnDisabled : {}),
              }}
              disabled={submitting || !form.consentChecked}
              onClick={handleSubmit}
            >
              {submitting ? (
                <><span style={CS.spinner} /> Recording Consent...</>
              ) : (
                <> Accept & Proceed</>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanConsentModal;
